var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-tabs",
        { attrs: { fill: "" } },
        [
          _c(
            "b-tab",
            { staticClass: "m-0", attrs: { title: "DEVOLUÇÕES", active: "" } },
            [
              _c(
                "b-card",
                { staticClass: "border-top-0" },
                [_c("vDevolucaoAdmList")],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-tab",
            { staticClass: "m-0", attrs: { title: "DEVOLUÇÕES SOLICITADAS" } },
            [
              _c(
                "b-card",
                { staticClass: "border-top-0 text-center" },
                [
                  _c("h3", [_vm._v("DEVOLUÇÕES SOLICITADAS")]),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-0",
                              attrs: {
                                label: "Status:",
                                "label-for": "filter-input",
                                "label-cols-sm": "3",
                                "label-align-sm": "right",
                                "label-size": "sm"
                              }
                            },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "sm",
                                  options: _vm.optionStatus
                                },
                                on: { change: _vm.loadData },
                                model: {
                                  value: _vm.status,
                                  callback: function($$v) {
                                    _vm.status = $$v
                                  },
                                  expression: "status"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-0",
                              attrs: {
                                label: "Lote:",
                                "label-for": "filter-input",
                                "label-cols-sm": "3",
                                "label-align-sm": "right",
                                "label-size": "sm"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  size: "sm",
                                  id: "filter-input",
                                  type: "number",
                                  placeholder: "Procurar Lote"
                                },
                                model: {
                                  value: _vm.lote,
                                  callback: function($$v) {
                                    _vm.lote = $$v
                                  },
                                  expression: "lote"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              staticClass: "mb-0",
                              attrs: {
                                label: "NF:",
                                "label-for": "filter-input",
                                "label-cols-sm": "3",
                                "label-align-sm": "right",
                                "label-size": "sm"
                              }
                            },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  size: "sm",
                                  id: "filter-input",
                                  type: "number",
                                  placeholder: "Procurar NF"
                                },
                                model: {
                                  value: _vm.nf,
                                  callback: function($$v) {
                                    _vm.nf = $$v
                                  },
                                  expression: "nf"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { size: "sm", variant: "primary" },
                              on: { click: _vm.loadData }
                            },
                            [_vm._v(" Buscar ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "row mt-3" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("b-table", {
                          attrs: {
                            items: _vm.dataComputed,
                            fields: _vm.colunas,
                            "sort-by": _vm.sortBy,
                            "sort-desc": _vm.sortDesc,
                            "sort-direction": _vm.sortDirection,
                            hover: "",
                            striped: "",
                            bordered: "",
                            small: "",
                            "current-page": _vm.currentPage,
                            "per-page": _vm.perPage,
                            busy: _vm.loading,
                            stacked: "md",
                            "show-empty": "",
                            filter: _vm.filter,
                            "filter-included-fields": _vm.filterOn,
                            "empty-text": "Nenhuma nota fiscal encontrada ..."
                          },
                          on: {
                            "update:sortBy": function($event) {
                              _vm.sortBy = $event
                            },
                            "update:sort-by": function($event) {
                              _vm.sortBy = $event
                            },
                            "update:sortDesc": function($event) {
                              _vm.sortDesc = $event
                            },
                            "update:sort-desc": function($event) {
                              _vm.sortDesc = $event
                            },
                            filtered: _vm.onFiltered
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "table-busy",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-center text-danger my-2"
                                    },
                                    [
                                      _c("b-spinner", {
                                        staticClass: "align-middle"
                                      }),
                                      _vm._v(" "),
                                      _c("strong", [_vm._v("Carregando ...")])
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            },
                            {
                              key: "cell(id)",
                              fn: function(data) {
                                return [
                                  _c(
                                    "b-button",
                                    {
                                      directives: [
                                        {
                                          name: "b-modal",
                                          rawName: "v-b-modal.modal-center",
                                          modifiers: { "modal-center": true }
                                        }
                                      ],
                                      attrs: { variant: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.show(data.item.id)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "fas fa-eye" })]
                                  )
                                ]
                              }
                            },
                            {
                              key: "cell(aproved)",
                              fn: function(data) {
                                return [
                                  _c("div", [
                                    _c("p", { staticClass: "m-0" }, [
                                      _c("b", [
                                        _vm._v(_vm._s(data.item.aproved))
                                      ])
                                    ])
                                  ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("b-pagination", {
                          staticClass: "my-0",
                          attrs: {
                            "total-rows": _vm.totalRows,
                            "per-page": _vm.perPage,
                            align: "fill",
                            size: "sm"
                          },
                          model: {
                            value: _vm.currentPage,
                            callback: function($$v) {
                              _vm.currentPage = $$v
                            },
                            expression: "currentPage"
                          }
                        })
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            title: "Devolução da Nota " + _vm.danfe.numero,
            centered: "",
            size: "xl"
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _vm.danfe.status == "AGUARDANDO APROVACAO" &&
                  _vm.permissionApprove &&
                    _vm.permissionApprove.name == "approve_returns"
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-warning",
                          attrs: { type: "button", "data-dismiss": "modal" },
                          on: {
                            click: function($event) {
                              return _vm.aprovarDevolucao()
                            }
                          }
                        },
                        [_vm._v("\r\n                Aprovar\r\n            ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button", "data-dismiss": "modal" },
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [_vm._v("\r\n                Fechar\r\n            ")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.openModal,
            callback: function($$v) {
              _vm.openModal = $$v
            },
            expression: "openModal"
          }
        },
        [
          _c(
            "ul",
            { staticClass: "text-danger" },
            [
              _vm._l(_vm.errors, function(error) {
                return _c("li", { key: error }, [_vm._v(_vm._s(error))])
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.danfe.danfe_id,
                    expression: "danfe.danfe_id"
                  }
                ],
                attrs: { type: "hidden" },
                domProps: { value: _vm.danfe.danfe_id },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.danfe, "danfe_id", $event.target.value)
                  }
                }
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm.danfe.status == "LIBERADO"
            ? _c("div", [
                _vm.danfe.analise.length > 0
                  ? _c("div", [
                      _c("h4", [
                        _vm._v(
                          "\r\n                    Demostrativo da análise, mediante a solicitação de devolução.\r\n                "
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "table",
                        {
                          staticClass:
                            "table table-bordered table-condensed table-hover"
                        },
                        [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [_vm._v("Regras")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("% Multa")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Quantidade")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Media")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("NF. Vs Media")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Taxa")]),
                              _vm._v(" "),
                              _c("th", [_vm._v("Subtotal")])
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.danfe.analise, function(an) {
                              return _c("tr", { key: an }, [
                                _c("td", [_vm._v(_vm._s(an.descricao))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(an.multa) + " %")]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(an.quantidade))]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\r\n                                R$ " +
                                      _vm._s(
                                        parseFloat(an.media).toLocaleString(
                                          "pt-BR"
                                        )
                                      ) +
                                      "\r\n                            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\r\n                                R$\r\n                                " +
                                      _vm._s(
                                        parseFloat(
                                          an.nf_x_media
                                        ).toLocaleString("pt-BR")
                                      ) +
                                      "\r\n                            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\r\n                                R$ " +
                                      _vm._s(
                                        parseFloat(an.taxa).toLocaleString(
                                          "pt-BR"
                                        )
                                      ) +
                                      "\r\n                            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\r\n                                R$ " +
                                      _vm._s(
                                        parseFloat(an.total).toLocaleString(
                                          "pt-BR"
                                        )
                                      ) +
                                      "\r\n                            "
                                  )
                                ])
                              ])
                            }),
                            0
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.danfe.obs,
                      expression: "danfe.obs"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { readonly: "" },
                  domProps: { value: _vm.danfe.obs },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.danfe, "obs", $event.target.value)
                    }
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.danfe.status == "ABERTO" || _vm.danfe.status != "LIBERADO"
            ? _c("div", [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-4" }, [
                    _c("h5", [_vm._v("Revendedora")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("span", [_vm._v(_vm._s(_vm.danfe.nome))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-4" }, [
                    _c("h5", [_vm._v("Chave da Nota")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("span", [_vm._v(_vm._s(_vm.danfe.chave))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-4" }, [
                    _c("h5", [_vm._v("Número da Nota")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("span", [_vm._v(_vm._s(_vm.danfe.numero))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("Tipo Devolução:")]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.danfe.tipo,
                              expression: "danfe.tipo"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { disabled: "", id: "tipo-devolve" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.danfe,
                                "tipo",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { domProps: { value: 1 } }, [
                            _vm._v("Total")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 2 } }, [
                            _vm._v("Parcial")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 3 } }, [
                            _vm._v("Extravio")
                          ])
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("Tipo de Frete:")]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.danfe.frete,
                              expression: "danfe.frete"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { disabled: "", id: "tipo-frete" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.danfe,
                                "frete",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { domProps: { value: 1 } }, [
                            _vm._v("Proprio")
                          ]),
                          _vm._v(" "),
                          _c("option", { domProps: { value: 2 } }, [
                            _vm._v("Coleta")
                          ])
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_vm._v("Justificativa:")]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.danfe.justificativa,
                            expression: "danfe.justificativa"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { disabled: "", rows: "2", cols: "3" },
                        domProps: { value: _vm.danfe.justificativa },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.danfe,
                              "justificativa",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-6" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _vm.files
                        ? _c("img", {
                            staticClass: "img-rounded vue-image",
                            attrs: { src: _vm.files, width: "200" }
                          })
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _vm.danfe.tipo == 2
                    ? _c("div", { staticClass: "form-group" }, [
                        _c("table", { staticClass: "table table-responsive" }, [
                          _c("thead", [
                            _c("th", [_vm._v("Selecione...")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Produto")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Descricao")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Quantidade")])
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.danfe.itens, function(itens) {
                              return _c("tr", { key: itens }, [
                                _c("td", [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.itensDevolve,
                                        expression: "itensDevolve"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      value: itens.id,
                                      checked: Array.isArray(_vm.itensDevolve)
                                        ? _vm._i(_vm.itensDevolve, itens.id) >
                                          -1
                                        : _vm.itensDevolve
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.itensDevolve,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = itens.id,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.itensDevolve = $$a.concat([
                                                $$v
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.itensDevolve = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.itensDevolve = $$c
                                        }
                                      }
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\r\n                                    " +
                                      _vm._s(itens.produto) +
                                      "\r\n                                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\r\n                                    " +
                                      _vm._s(itens.descricao) +
                                      "\r\n                                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\r\n                                    " +
                                      _vm._s(itens.quantidade) +
                                      "\r\n                                "
                                  )
                                ])
                              ])
                            }),
                            0
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a7b77cb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a7b77cb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_devolucao/List.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-6a7b77cb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_devolucao/List.vue
// module chunks = 2